export enum ColourSchemas {
  primary = 'primary',
  secondary = 'secondary',
  gosScheme = 'gos-scheme',
}

export interface IColourSchema {
  id: number;
  name: ColourSchemas;
}
